import { ChrAuthClient } from '@chr/common-web-ui-authentication/authClient';
import React, { FC, useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { UserProfile } from '@chr/online-shared-microsite-core';
import { ConnectedApp } from './app.component';
import { GatewayApi } from './common/apis/gatewayApi';
import { storeFactory } from './common/state-management/store-factory';
import { AppLoader } from './AppLoader';

interface AppWrapperProps {
  appConfig: AppConfig;
  authClient: ChrAuthClient;
  userProfile: UserProfile;
}
export const AppWrapper: FC<AppWrapperProps> = (props) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    GatewayApi.init(
      props.appConfig.gatewayApiUri,
      props.appConfig,
      props.authClient
    );
    setLoaded(true);
  }, [props.appConfig, props.authClient]);

  if (!loaded) {
    return null;
  }

  const store = storeFactory(props.appConfig);

  return (
    <Provider store={store}>
      <AppLoader>
        <ConnectedApp
          appConfig={props.appConfig}
          authClient={props.authClient}
          userProfile={props.userProfile}
        />
      </AppLoader>
    </Provider>
  );
};
